var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    focusable: "false",
    width: 14,
    height: 24,
    viewBox: "0 0 14 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1 0H2.9C1.3 0 0 1.3 0 2.9V21.1C0 22.7 1.3 24 2.9 24H11.1C12.7 24 14 22.7 14 21.1V2.9C14 1.3 12.7 0 11.1 0ZM2.9 2H11.1C11.6 2 12 2.4 12 2.9V3H2V2.9C2 2.4 2.4 2 2.9 2ZM12 5V16H2V5H12ZM11.1 22H2.9C2.4 22 2 21.6 2 21.1V18H12V21.1C12 21.6 11.6 22 11.1 22Z",
    fill: "#2C94AB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 21C7.55228 21 8 20.5523 8 20C8 19.4477 7.55228 19 7 19C6.44772 19 6 19.4477 6 20C6 20.5523 6.44772 21 7 21Z",
    fill: "#2C94AB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobile);
export default __webpack_public_path__ + "static/media/mobile.4d16c983113482d082f0bf6c32dab34a.svg";
export { ForwardRef as ReactComponent };